export const VIEW_STATE_NONE = "";
export const VIEW_STATE_ACTIVE = "active";
export const VIEW_STATE_FULL = "fullscreen";
